export function CrossIcon({ className, color = "black" }: { className?: string, color?: string }) {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" className={className}>
      <path d="M7 7L21 21M21 7L7 21" stroke={color} strokeWidth="1.75" strokeLinecap="square"/>
</svg>
  );
}